import React from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';

const commonFields = [
  'Computer Science',
  'Machine Learning',
  'Artificial Intelligence',
  'Natural Language Processing',
  'Deep Learning',
  'Neural Networks',
  'Data Science',
  'Mathematics',
  'Physics',
  'Biology'
];

const FieldsFilter = ({ value, onChange }) => {
  return (
    <Autocomplete
      multiple
      options={commonFields}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Filter by Fields"
          placeholder="Select fields..."
        />
      )}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            label={option}
            {...getTagProps({ index })}
            key={option}
            size="small"
          />
        ))
      }
    />
  );
};

export default FieldsFilter; 